import React, { useRef } from "react";
import { Typography, Box, Button, Grid, Chip } from "@mui/material";
import { Formik, Form } from "formik";
import ErrorIcon from "@mui/icons-material/Error";
import * as Yup from "yup";
import Signature from "../../../../common/signature/signature";
import "./e-safety-contract.css";

// Define validation schema
const validationSchema = Yup.object().shape({
  agree: Yup.boolean().oneOf([true], "You must accept the terms to proceed."),
});

const ESafetyContractAdmission = () => {
  const signatureRef = useRef(null);

  // Initial form values
  const initialValues = {
    agree: true,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const signatureData = signatureRef.current.getSignatureData();
        if (!signatureData) {
          alert("Please provide a signature");
          return;
        }

        const formData = { ...values, signature: signatureData };

        console.log("Form data submitted:", formData);
      }}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit} className='admission-form'>
          {/* Header Section */}
          <Box className='header-section-safety'>
            <Chip label='Admission' />
            <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
              E Safety Contract
            </Typography>
            <Typography sx={{ fontSize: "14px" }} align='left'>
              Agreement outlining responsible internet usage, prohibiting harmful online behavior, and promoting safety.
            </Typography>
          </Box>
          <Box className='agreement-section' display='flex' alignItems='center'>
            <ErrorIcon color='primary' />
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              You have the right to use the internet but you also have the responsibility to use it sensibly and safely.
            </Typography>
          </Box>

          {/* Content Section */}
          <Box className='content-section' ml={2}>
            <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>I will not:</Typography>
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              <ul>
                <li>Try to access any rude material on the internet.</li>
                <li>Download unnecessary pictures, music, video clips, etc.</li>
                <li>Send bulk emails to a large group.</li>
              </ul>
            </Typography>
            <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>I will:</Typography>
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              <ul>
                <li>Always use polite language in my emails.</li>
                <li>Clear any spam from my mailbox immediately.</li>
                <li>Report any misuse to staff.</li>
                <li>Tell staff if someone or something on the internet makes me feel uncomfortable.</li>
              </ul>
            </Typography>
            <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>I will never:</Typography>
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              <ul>
                <li>Give out my name, address, or mobile number to people on the Internet.</li>
                <li>Agree to meet people who I have only known through the internet.</li>
                <li>Send photographs of myself or anyone over the internet.</li>
              </ul>
            </Typography>
          </Box>
          <Box className='agreement-section' display='flex' alignItems='center' mt={5}>
            <ErrorIcon color='primary' />
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              I have read and understand the e safety rules and agree to follow them.  I understand that if I do not
              follow them I will not be allowed to use the internet until this is reiewed by all proffessionals involved
              in my care.
            </Typography>
          </Box>

          {/* Signature Section */}
          
          <Box className='signature-box'>
            <Signature ref={signatureRef} />
            <Typography align='right'>
              <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Venorox</Typography>

              <Grid className='clear-signature-button'>
                <Button variant='outlined' onClick={() => signatureRef.current?.clearSignature()}>
                  Clear
                </Button>
              </Grid>
            </Typography>
          </Box>

          {/* Submit Button */}
          <Grid item xs={12} mr={1}>
            <div className='submit-button-container'>
              <Button type='submit' variant='contained' color='primary' className='submit-button'>
                Submit
              </Button>
            </div>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default ESafetyContractAdmission;
